import React from 'react';
import { LoadingDots } from './loading-dots';

export function LoadingDotsDrawer() {
  return <LoadingDots className="pos-a center-xy" dotClassName="p-0_5" />;
}
